import TripleDotDropdown from './TripleDotDropdown'

export default TripleDotDropdown



// WEBPACK FOOTER //
// app/javascript/components/frags/TripleDotDropdown/index.js